import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import Modal from '../components/Modal';
import StandardButton from '../components/StandardButton';
import Text from '../components/Text'; // TODO: rework this to use Text component
import { setCurrentModal } from '../thunks/setCurrentModal';
import { useAppSelector, useAppDispatch } from '../app/hooks';

export const GIFTCARD_PURCHASE_SUCCESSFUL_MODAL = 'GIFTCARD_PURCHASE_SUCCESSFUL_MODAL';

const GiftcardSuccessModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const modalParams = useAppSelector(state => state.modalParams);
  const { giftcard, isGift, purchaserEmail, recipientEmail, scheduled, sendTime } =
    modalParams ?? {};

  let bodyKey = 'giftCardSuccessBodySelf';
  if (isGift) {
    bodyKey = scheduled ? 'giftCardSuccessBodyScheduled' : 'giftCardSuccessBodyGiftNow';
  }

  return (
    <Modal
      title={modalParams?.title}
      desktopMaxWidth={350}
      desktopMinWidth={350}
      hideFloatingHeader
    >
      <Text block value={t('giftCardSuccessTitle')} themeKey="messageModalMessage" />
      <Text
        block
        value={t(bodyKey, {
          purchaserEmail,
          recipientEmail,
          sendTime: sendTime ? moment(sendTime).format('LLL') : undefined,
        })}
        themeKey="messageModalMessage"
      />

      {giftcard?.SalesID && (
        <Text
          block
          value={t('giftCardSuccessReceipt', { salesId: giftcard.SalesID })}
          themeKey="messageModalMessage"
        />
      )}

      <StandardButton
        label={t('button.ok')}
        onClick={() => dispatch(setCurrentModal(null))}
        themeKey="messageModalButton"
      />
    </Modal>
  );
};

export default GiftcardSuccessModal;
